import { forwardRef, ReactNode } from 'react';

interface ViewerLiveWebinarLayoutProps {
    children: ReactNode;
    banner?: ReactNode;
    isLandscape: boolean;
    isMobileEnabled: boolean;
}

export const ViewerLiveWebinarLayout = forwardRef<HTMLDivElement, ViewerLiveWebinarLayoutProps>(
    ({ children, banner, isLandscape, isMobileEnabled }: ViewerLiveWebinarLayoutProps, ref) => (
        // A flex column in both branches, with the height requirement on #ow-viewer and the grid as
        // the growing child, so the banner and the grid share that height instead of the banner
        // being added to it: on mobile the banner would otherwise push the grid past the fixed
        // 100dvh (clipping the menu below the fold), on desktop past --viewer-min-height (100dvh in
        // every tenant theme), which is a scrollbar of exactly the banner's height for every viewer.
        // Without a banner it is a no-op: the grid is the only child, so it takes the whole column —
        // exactly 100dvh on mobile (h-dvh), and on desktop the column's own height, which is
        // max(--viewer-min-height, content) because a growing flex item still contributes its
        // content size to an auto-height flex container.
        <div
            ref={ref}
            id="ow-viewer"
            className={`@container/viewer bg-[var(--viewer-background-color)] text-[var(--viewer-text-color)] flex flex-col ${isMobileEnabled ? 'h-dvh' : 'min-h-[var(--viewer-min-height)]'}`}
        >
            {banner}
            <div
                className={`max-w-full grid flex-1 min-h-0 ${isMobileEnabled ? (isLandscape ? 'grid-cols-[1fr_max-content]' : 'grid-cols-1 grid-rows-[auto_1fr_auto]') : 'grid-cols-[1fr_clamp(19rem,30cqi,25rem)] grid-rows-[auto_1fr_auto]'}`}
            >
                {children}
            </div>
        </div>
    )
);
